import axios from 'api/axios'
import { Invoice } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

export interface DeleteInvoiceParams {
	id: string
	hardDelete?: boolean
}

/**
 * API call for delete Invoice
 * @param option DeleteInvoiceParams - to be send to backend for delete single invoice
 * @returns DeletedInvoiceResponse - Response object returned from the server
 */

export const deleteInvoice = async (option: DeleteInvoiceParams) => {
	const { id, hardDelete } = option
	try {
		const { data } = await axios.delete<Invoice>(
			`client/bill/invoice/${id}?${hardDelete ? `&hardDelete=${hardDelete}` : ''}`
		)

		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default deleteInvoice
